import currentClientConfig from "../../config";
export const natcatSelectionText = currentClientConfig.natCatPolicySelectionText;
export const natcatEuroText = currentClientConfig.natCatEuroExplanationText;
